function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.addEventListener("maison:update-cart", () => {
  fetch("/cart/update.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      updates: {},
      sections: ["cart-drawer", "cart-icon-bubble"],
    }),
  })
    .then((response) => response.json())
    .then((cart) => {
      // Update cart drawer contents
      document.querySelector("cart-drawer").renderContents(cart);
      document.querySelector("cart-drawer.drawer").classList.remove("is-empty");

      // Open cart drawer
      document.querySelector("cart-drawer").open();
    })
    .catch((error) => {
      console.error("Error:", error);
    });
});

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer, menu-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === "INPUT" &&
    ["search", "text", "email", "url"].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options["hideElement"] || province_domid);

  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.localization-selector)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector("button"));
      summaryElement.nextElementSibling.removeEventListener("transitionend", addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia("(max-width: 990px)")) {
        document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener("transitionend", addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle.querySelectorAll(".submenu-open").forEach((submenu) => {
      submenu.classList.remove("submenu-open");
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute("aria-expanded", false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement.querySelector("summary").setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector(".section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains("header-wrapper--border-bottom")
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    window.addEventListener("resize", this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open");
    window.removeEventListener("resize", this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        "--header-bottom-position",
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty("--viewport-height", `${window.innerHeight}px`);
  };
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (event.pointerType === "mouse" && !event.target.closest("deferred-media, product-model"))
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    //window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    //window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(this.querySelector("template").content.firstElementChild.cloneNode(true));

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == "VIDEO" && deferredElement.getAttribute("autoplay")) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector(".announcement-bar-slider");
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
      this.reducedMotion.addEventListener("change", () => {
        if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute("data-autoplay") === "true") this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    if (this.querySelector(".slideshow__autoplay")) {
      this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
      this.sliderAutoplayButton.addEventListener("click", this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked
        ? this.pause()
        : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add("slider-counter__link--active");
    this.sliderControlButtons[this.currentPage - 1].setAttribute("aria-current", true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton ||
        this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll("a");
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute("tabindex");
          });
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute("tabindex", "-1");
          });
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = "next") {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === "next" ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = "announcement-bar-slider--fade-in";
    const animationClassOut = "announcement-bar-slider--fade-out";

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext =
      (button === "next" && !isLastSlide) || (button === "previous" && isFirstSlide);
    const direction = shouldMoveNext ? "next" : "previous";

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

let bundleInitialized = false;
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);

    // Initialize bundle display with the initial variant when the component is created
    if (!bundleInitialized) {
      setTimeout(() => {
        console.log("Initializing bundle display");
        this.initializeBundleDisplay();
      }, 100);
      bundleInitialized = true;
    }
  }

  // Initialize bundle display with the initial variant
  initializeBundleDisplay() {
    // Check if the document is already loaded
    if (document.readyState === "complete" || document.readyState === "interactive") {
      this.initBundleWithDelay();
    } else {
      // Wait for DOM to be fully loaded
      window.addEventListener("DOMContentLoaded", () => {
        this.initBundleWithDelay();
      });
    }
  }

  // Helper method to initialize bundle with delay
  initBundleWithDelay() {
    // Use an interval to check for bundleData availability
    let cleared = false;
    const checkInterval = setInterval(() => {
      if (window.bundleData) {
        cleared = true;
        clearInterval(checkInterval);

        this.updateOptions();
        this.updateMasterId();

        if (this.currentVariant) {
          console.log("Initializing bundle display with variant:", this.currentVariant.id);
          this.updateBundleDisplay(this.currentVariant.id);
        }
      }
    }, 100);

    // Set a timeout to stop checking after 5 seconds
    setTimeout(() => {
      if (!cleared) {
        clearInterval(checkInterval);
        console.log("Timed out waiting for bundle data");
      }
    }, 5000);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();

    // Log the current variant to console
    if (this.currentVariant) {
      console.log("Variant changed:", this.currentVariant);

      // Try to get metafields from the DOM
      const metafieldElement = this.querySelector("[data-variant-metafields]");
      if (metafieldElement) {
        try {
          const metafields = JSON.parse(metafieldElement.textContent);
          if (metafields && metafields.custom && metafields.custom.bundle_variant_info) {
            console.log("Bundle variant info:", metafields.custom.bundle_variant_info);
            console.log(metafields.custom.bundle_variant_info);
          } else {
            console.log("No bundle_variant_info metafield found for this variant");
          }
        } catch (e) {
          console.error("Error parsing variant metafields:", e);
        }
      }

      // Update bundle display with the current variant
      this.updateBundleDisplay(this.currentVariant.id);
    }

    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll("select"), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(
        `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
        true
      )
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(":checked").value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".product-form__input")];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(":checked").value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) => variant.available && variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.innerText = input.getAttribute("value");
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace(
          "[value]",
          input.getAttribute("value")
        );
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection
      ? this.dataset.originalSection
      : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        const skuSource = html.getElementById(
          `Sku-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        // Update variant metafields
        const newMetafieldElement = html.querySelector("[data-variant-metafields]");
        const currentMetafieldElement = this.querySelector("[data-variant-metafields]");

        if (newMetafieldElement && currentMetafieldElement) {
          currentMetafieldElement.textContent = newMetafieldElement.textContent;

          // Log the updated metafields
          try {
            const metafields = JSON.parse(newMetafieldElement.textContent);
            if (metafields && metafields.custom && metafields.custom.bundle_variant_info) {
              console.log("Updated bundle variant info:", metafields.custom.bundle_variant_info);
            }
          } catch (e) {
            console.error("Error parsing updated variant metafields:", e);
          }
        }

        const volumePricingSource = html.getElementById(
          `Volume-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );

        const pricePerItemDestination = document.getElementById(
          `Price-Per-Item-${this.dataset.section}`
        );
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${
            this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
          }`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        // Check for variant metafields in the returned HTML
        const metafieldElement = html.querySelector("[data-variant-metafields]");
        if (metafieldElement) {
          try {
            const metafields = JSON.parse(metafieldElement.textContent);
            if (metafields && metafields.custom && metafields.custom.bundle_variant_info) {
              console.log(
                "Bundle variant info (from section render):",
                metafields.custom.bundle_variant_info
              );
            }
          } catch (e) {
            console.error("Error parsing variant metafields:", e);
          }
        }

        if (volumeNote) volumeNote.classList.remove("hidden");
        if (volumePricingDestination) volumePricingDestination.classList.remove("hidden");
        if (qtyRules) qtyRules.classList.remove("hidden");

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination)
          inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle("hidden", skuSource.classList.contains("hidden"));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle(
            "hidden",
            pricePerItemSource.classList.contains("hidden")
          );
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("hidden");

        if (inventoryDestination)
          inventoryDestination.classList.toggle("hidden", inventorySource.innerText === "");

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);

        // Only pass the disabled state to toggleAddButton, not the text content
        // This way our custom logic in toggleAddButton will handle updating the button content
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute("disabled") : true,
          null, // Don't override the text
          false // Don't modify class
        );

        this.updateStickyATC(html);
        this.updateTiered(html);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      // Only replace text content if explicitly provided and not null
      if (text) {
        addButtonText.textContent = text;
      } else if (this.currentVariant && !this.currentVariant.available) {
        // If it's disabled because it's sold out, set text to "Sold Out"
        // Preserve SVG if present
        const currentContent = addButtonText.innerHTML;
        if (currentContent.includes("<svg") && currentContent.includes("cart-icon")) {
          addButtonText.innerHTML =
            extractSvgIcon(currentContent) + " " + window.variantStrings.soldOut;
        } else {
          addButtonText.textContent = window.variantStrings.soldOut;
        }
      }
    } else {
      addButton.removeAttribute("disabled");
      // Save the current content of the button span to preserve SVG and other elements
      const currentContent = addButtonText.innerHTML;

      // Check if we already have SVG in the content
      if (currentContent.includes("<svg") && currentContent.includes("cart-icon")) {
        // Extract SVG icon and update text
        const svgIcon = extractSvgIcon(currentContent);
        const priceText = this.currentVariant ? ` - ${formatMoney(this.currentVariant.price)}` : "";
        const textContent = window.variantStrings.addToCart + priceText;

        // Set new content with SVG + updated text
        addButtonText.innerHTML = svgIcon + " " + textContent;
      } else {
        // If SVG is missing, re-render full content from original template
        const cartIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="cart-icon" style="width: 24px; height: 24px; vertical-align: middle; margin-bottom: 5px; display: inline-block;"><path d="M2.05005 2.05005H4.05005L6.71005 14.47C6.80763 14.9249 7.06072 15.3315 7.42576 15.6199C7.7908 15.9083 8.24495 16.0604 8.71005 16.05H18.49C18.9452 16.0493 19.3865 15.8933 19.7411 15.6079C20.0956 15.3224 20.3422 14.9246 20.4401 14.48L22.09 7.05005H5.12005M9 21C9 21.5523 8.55228 22 8 22C7.44772 22 7 21.5523 7 21C7 20.4477 7.44772 20 8 20C8.55228 20 9 20.4477 9 21ZM20 21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21C18 20.4477 18.4477 20 19 20C19.5523 20 20 20.4477 20 21Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
        const cartText = window.variantStrings.addToCart;
        const priceText = this.currentVariant ? ` - ${formatMoney(this.currentVariant.price)}` : "";

        addButtonText.innerHTML = `${cartIcon} ${cartText}${priceText}`;
      }
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;

    // Save the current HTML of the button to preserve SVG icon
    const currentContent = addButtonText.innerHTML;
    if (currentContent.includes("<svg") && currentContent.includes("cart-icon")) {
      // Extract SVG icon and set with unavailable text
      const svgIcon = extractSvgIcon(currentContent);
      addButtonText.innerHTML = svgIcon + " " + window.variantStrings.unavailable;
    } else {
      // If no SVG, just set the text content
      addButtonText.textContent = window.variantStrings.unavailable;
    }

    if (price) price.classList.add("hidden");
    if (inventory) inventory.classList.add("hidden");
    if (sku) sku.classList.add("hidden");
    if (pricePerItem) pricePerItem.classList.add("hidden");
    if (volumeNote) volumeNote.classList.add("hidden");
    if (volumeTable) volumeTable.classList.add("hidden");
    if (qtyRules) qtyRules.classList.add("hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  // New method to update bundle display based on variant ID
  updateBundleDisplay(variantId) {
    // Check if bundleData exists and has data for this product and variant
    if (typeof window.bundleData === "undefined" || !window.bundleData) {
      console.log("Bundle data not available");
      this.updateBundleAddAllButton(false);
      return;
    }

    const productId = Object.keys(window.bundleData)[0]; // Assuming there's only one product in bundleData
    if (!productId || !window.bundleData[productId] || !window.bundleData[productId][variantId]) {
      console.log("No bundle data for this variant:", variantId);
      this.updateBundleAddAllButton(false);
      return;
    }

    const bundleItems = structuredClone(window.bundleData[productId][variantId]);
    console.log("Updating bundle display with:", bundleItems);
    window.pickedVariants = bundleItems;

    // Find the bundle container
    const bundleContainer = document.querySelector(".mc-bundle-filled-select-416928-1608");
    if (!bundleContainer) {
      console.log("Bundle container not found");
      this.updateBundleAddAllButton(false);
      return;
    }

    // If no bundle items or null, hide the bundle container and add all button
    if (!bundleItems || !Array.isArray(bundleItems) || bundleItems.length === 0) {
      bundleContainer.style.display = "none";
      this.updateBundleAddAllButton(false);
      return;
    }

    // Show the bundle container
    bundleContainer.style.display = "flex";

    // Save the feature text element before clearing the container
    const featureTextElement = bundleContainer.querySelector(".mc-feature-text-416928-3913");
    const featureText = featureTextElement ? featureTextElement.textContent : "";

    // Clear the container
    bundleContainer.innerHTML = "";

    // Recreate the feature text element
    if (featureText) {
      const newFeatureText = document.createElement("span");
      newFeatureText.className = "mc-feature-text-416928-3913";
      newFeatureText.textContent = featureText;
      bundleContainer.appendChild(newFeatureText);
    }

    // Create and append bundle items
    bundleItems.forEach((item, index) => {
      const itemElement = this.createBundleItemElement(item, index);
      bundleContainer.appendChild(itemElement);
    });

    // Update the Add All button visibility
    this.updateBundleAddAllButton(true, bundleItems.length);
  }

  // Helper method to update the Add All button visibility
  updateBundleAddAllButton(show, itemCount = 0) {
    const addAllContainer = document.querySelector(".mc-bundle-add-all-container");
    if (!addAllContainer) return;

    if (show && itemCount > 0) {
      addAllContainer.style.display = "block";

      // Update button text to show item count
      const addAllButton = document.getElementById("bundle-add-all-button");
      if (addAllButton) {
        addAllButton.textContent = `Add All ${itemCount} Bundle Items to Cart`;
      }
    } else {
      addAllContainer.style.display = "none";
    }
  }

  // Helper method to create a bundle item element
  createBundleItemElement(item, index) {
    // Create main content container
    const contentContainer = document.createElement("div");
    contentContainer.className = `mc-content-${index}-5873`;
    contentContainer.style.display = "flex";
    contentContainer.style.flexDirection = "column";
    contentContainer.style.alignItems = "flex-start";
    contentContainer.style.gap = "8px";
    contentContainer.style.alignSelf = "stretch";
    contentContainer.style.width = "100%";

    // Create attribute container
    const attributeContainer = document.createElement("div");
    attributeContainer.className = `mc-attribute-${index}-0046`;
    attributeContainer.style.display = "flex";
    attributeContainer.style.padding = "12px";
    attributeContainer.style.flexDirection = "column";
    attributeContainer.style.alignItems = "center";
    attributeContainer.style.gap = "4px";
    attributeContainer.style.alignSelf = "stretch";
    attributeContainer.style.border = "1px solid #F4F0E7";
    attributeContainer.style.background = "#FCFAF8";
    contentContainer.appendChild(attributeContainer);

    // Create inner content container
    const innerContent = document.createElement("div");
    innerContent.className = `mc-content-${index}-9563`;
    innerContent.style.display = "flex";
    innerContent.style.alignItems = "flex-start";
    innerContent.style.gap = "12px";
    innerContent.style.alignSelf = "stretch";
    attributeContainer.appendChild(innerContent);

    // Create image container
    const imageContainer = document.createElement("div");
    imageContainer.className = `mc-image-${index}-3935`;
    imageContainer.style.display = "flex";
    imageContainer.style.width = "64px";
    imageContainer.style.height = "64px";
    imageContainer.style.justifyContent = "center";
    imageContainer.style.alignItems = "center";
    imageContainer.style.gap = "10px";
    imageContainer.style.aspectRatio = "1/1";

    // Set image background
    if (item.featured_image && item.featured_image.src) {
      imageContainer.style.background = `url(${item.featured_image.src}) lightgray 50% / cover no-repeat`;
    } else {
      imageContainer.style.background = "lightgray 50% / cover no-repeat";
    }
    innerContent.appendChild(imageContainer);

    // Create details container
    const detailsContainer = document.createElement("div");
    detailsContainer.className = `mc-content-${index}-6376`;
    detailsContainer.style.display = "flex";
    detailsContainer.style.flexDirection = "column";
    detailsContainer.style.alignItems = "flex-start";
    detailsContainer.style.gap = "4px";
    detailsContainer.style.flex = "1 0 0";
    innerContent.appendChild(detailsContainer);

    // Create title section
    const titleSection = document.createElement("div");
    titleSection.className = `mc-content-${index}-5959`;
    titleSection.style.display = "flex";
    titleSection.style.alignItems = "flex-start";
    titleSection.style.gap = "16px";
    titleSection.style.alignSelf = "stretch";
    detailsContainer.appendChild(titleSection);

    // Create title container
    const titleContainer = document.createElement("div");
    titleContainer.className = `mc-title-${index}-7030`;
    titleContainer.style.display = "flex";
    titleContainer.style.flexDirection = "column";
    titleContainer.style.alignItems = "flex-start";
    titleContainer.style.flex = "1 0 0";
    titleSection.appendChild(titleContainer);

    // Create title element
    const titleElement = document.createElement("span");
    titleElement.className = `mc-title-${index}-8022`;
    titleElement.style.display = "-webkit-box";
    titleElement.style.webkitBoxOrient = "vertical";
    titleElement.style.webkitLineClamp = "1";
    titleElement.style.alignSelf = "stretch";
    titleElement.style.overflow = "hidden";
    titleElement.style.color = "#383633";
    titleElement.style.textOverflow = "ellipsis";
    titleElement.style.fontFamily = "Granary";
    titleElement.style.fontSize = "16px";
    titleElement.style.fontStyle = "normal";
    titleElement.style.fontWeight = "600";
    titleElement.style.lineHeight = "150%";
    titleElement.textContent = item.title || "";
    titleContainer.appendChild(titleElement);

    // Create options container
    const optionsContainer = document.createElement("div");
    optionsContainer.className = `mc-content-${index}-5915`;
    optionsContainer.style.display = "flex";
    optionsContainer.style.justifyContent = "center";
    optionsContainer.style.alignItems = "center";
    optionsContainer.style.gap = "4px";
    titleContainer.appendChild(optionsContainer);

    // Add option1 if available
    if (item.option1) {
      const option1Element = document.createElement("span");
      option1Element.className = `mc-title-${index}-7717`;
      option1Element.style.display = "-webkit-box";
      option1Element.style.webkitBoxOrient = "vertical";
      option1Element.style.webkitLineClamp = "18";
      option1Element.style.overflow = "hidden";
      option1Element.style.color = "#706D67";
      option1Element.style.textOverflow = "ellipsis";
      option1Element.style.fontFamily = "Granary";
      option1Element.style.fontSize = "14px";
      option1Element.style.fontStyle = "normal";
      option1Element.style.fontWeight = "500";
      option1Element.style.lineHeight = "150%";
      option1Element.textContent = item.option1;
      optionsContainer.appendChild(option1Element);
    }

    // Add separator dot if both options exist
    if (item.option1 && item.option2) {
      const dotElement = document.createElement("div");
      dotElement.className = `mc-dot-${index}-5883`;
      dotElement.style.width = "4px";
      dotElement.style.height = "4px";
      dotElement.style.backgroundColor = "#D0D5DD";
      dotElement.style.borderRadius = "50%";
      optionsContainer.appendChild(dotElement);
    }

    // Add option2 if available
    if (item.option2) {
      const option2Element = document.createElement("span");
      option2Element.className = `mc-title-${index}-7909`;
      option2Element.style.display = "-webkit-box";
      option2Element.style.webkitBoxOrient = "vertical";
      option2Element.style.webkitLineClamp = "18";
      option2Element.style.overflow = "hidden";
      option2Element.style.color = "#706D67";
      option2Element.style.textOverflow = "ellipsis";
      option2Element.style.fontFamily = "Granary";
      option2Element.style.fontSize = "14px";
      option2Element.style.fontStyle = "normal";
      option2Element.style.fontWeight = "500";
      option2Element.style.lineHeight = "150%";
      option2Element.textContent = item.option2;
      optionsContainer.appendChild(option2Element);
    }

    // Add customize/cancel link
    const actionLink = document.createElement("span");
    if (index === 0 || index === 1 || index === 2) {
      actionLink.className = `mc-customize-${index}-9119`;
      actionLink.textContent = "Customize";
    } else {
      actionLink.className = `mc-cancel-${index}-9518`;
      actionLink.textContent = "Cancel";
    }
    actionLink.style.color = "#6C7863";
    actionLink.style.fontFamily = "Granary";
    actionLink.style.fontSize = "16px";
    actionLink.style.fontStyle = "normal";
    actionLink.style.fontWeight = "600";
    actionLink.style.lineHeight = "150%";
    actionLink.style.textDecorationLine = "underline";
    titleSection.appendChild(actionLink);

    // Create price section
    const priceSection = document.createElement("div");
    priceSection.className = `mc-content-${index}-0426`;
    priceSection.style.display = "flex";
    priceSection.style.justifyContent = "space-between";
    priceSection.style.alignItems = "center";
    priceSection.style.alignSelf = "stretch";
    detailsContainer.appendChild(priceSection);

    // Create price container
    const priceContainer = document.createElement("div");
    priceContainer.className = `mc-price-${index}-0456`;
    priceContainer.style.display = "flex";
    priceContainer.style.alignItems = "center";
    priceContainer.style.gap = "8px";
    priceSection.appendChild(priceContainer);

    // Add compare at price if available
    if (item.compare_at_price && parseInt(item.compare_at_price) > 0) {
      const compareAtPriceElement = document.createElement("span");
      compareAtPriceElement.className = `mc-compare-price-${index}-3989`;
      compareAtPriceElement.style.color = "#9A968D";
      compareAtPriceElement.style.textAlign = "right";
      compareAtPriceElement.style.fontFamily = "Granary";
      compareAtPriceElement.style.fontSize = "14px";
      compareAtPriceElement.style.fontStyle = "normal";
      compareAtPriceElement.style.fontWeight = "500";
      compareAtPriceElement.style.lineHeight = "150%";
      compareAtPriceElement.style.textDecorationLine = "line-through";
      compareAtPriceElement.textContent = formatMoney(item.compare_at_price);
      priceContainer.appendChild(compareAtPriceElement);
    }

    // Add current price
    const priceElement = document.createElement("span");
    priceElement.className = `mc-price-${index}-0176`;
    priceElement.style.color = "#383633";
    priceElement.style.textAlign = "right";
    priceElement.style.fontFamily = "Granary";
    priceElement.style.fontSize = "16px";
    priceElement.style.fontStyle = "normal";
    priceElement.style.fontWeight = "600";
    priceElement.style.lineHeight = "150%";
    priceElement.textContent = formatMoney(item.price);
    priceContainer.appendChild(priceElement);

    return contentContainer;
  }
}

// Helper function to format money values
function formatMoney(cents) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  const value = parseInt(cents, 10);
  const dollars = Math.floor(value / 100);
  const cents_part = (value % 100).toString().padStart(2, "0");

  return `$${dollars}.${cents_part} USD`;
}

// Helper function to extract SVG icon from button content
function extractSvgIcon(content) {
  // Use a more precise regex to extract just the SVG element
  const svgMatch = content.match(/<svg[^>]*>[\s\S]*?<\/svg>/);
  return svgMatch ? svgMatch[0] : "";
}

// Function to add all bundle items to cart
window.addAllBundleItemsToCart = function () {
  // Get the current variant ID
  const currentVariantSelects = document.querySelector("variant-selects, variant-radios");
  if (!currentVariantSelects || !currentVariantSelects.currentVariant) {
    console.error("Current variant not found");
    showBundleMessage("Error: Could not find current variant", "error");
    return;
  }

  const currentVariantId = currentVariantSelects.currentVariant.id;

  // Get bundle items for the current variant
  if (!window.bundleData) {
    console.error("Bundle data not available");
    showBundleMessage("Error: Bundle data not available", "error");
    return;
  }

  const productId = Object.keys(window.bundleData)[0];
  if (
    !productId ||
    !window.bundleData[productId] ||
    !window.bundleData[productId][currentVariantId]
  ) {
    console.error("No bundle data for this variant:", currentVariantId);
    showBundleMessage("Error: No bundle items available for this variant", "error");
    return;
  }

  const bundleItems = structuredClone(window.bundleData[productId][currentVariantId]);
  if (!bundleItems || !Array.isArray(bundleItems) || bundleItems.length === 0) {
    console.error("No bundle items found");
    showBundleMessage("Error: No bundle items found", "error");
    return;
  }

  // Show loading state
  const addAllButton = document.getElementById("bundle-add-all-button");
  if (addAllButton) {
    addAllButton.textContent = "Adding...";
    addAllButton.disabled = true;
    addAllButton.style.backgroundColor = "#9A968D";
  }

  // Prepare items for cart

  const items = window.pickedVariants /*bundleItems*/
    .map((item) => {
      return {
        id: item.id,
        quantity: 1,
      };
    });

  // Add items to cart using Shopify AJAX API
  fetch("/cart/add.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ items }),
  })
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data) => {
      console.log("Bundle items added to cart:", data);

      // Update cart count and open cart drawer if available
      updateCartCount();

      // Reset button state
      if (addAllButton) {
        addAllButton.textContent = "Add All Bundle Items to Cart";
        addAllButton.disabled = false;
        addAllButton.style.backgroundColor = "#6C7863";
      }

      // Show success message
      showBundleMessage(`${items.length} bundle items added to cart!`, "success");

      // // Open cart drawer - use the global function explicitly with a small delay
      // setTimeout(() => {
      //   try {
      //     window.openCartDrawer();
      //   } catch (error) {
      //     console.error("Error opening cart drawer:", error);
      //     // If opening cart drawer fails, redirect to cart page
      //     setTimeout(() => {
      //       window.location.href = "/cart";
      //     }, 300);
      //   }
      // }, 300);

      document.dispatchEvent(new CustomEvent("maison:update-cart"));
    })
    .catch((error) => {
      console.error("Error adding bundle items to cart:", error);

      // Reset button state
      if (addAllButton) {
        addAllButton.textContent = "Add All Bundle Items to Cart";
        addAllButton.disabled = false;
        addAllButton.style.backgroundColor = "#6C7863";
      }

      // Show error message
      showBundleMessage("Error adding items to cart. Please try again.", "error");
    });
};

// Function to update cart count
function updateCartCount() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      const cartCountElements = document.querySelectorAll(".cart-count-bubble");
      cartCountElements.forEach((element) => {
        element.textContent = cart.item_count;
        element.classList.remove("hidden");
      });
    })
    .catch((error) => console.error("Error fetching cart:", error));
}

// Function to show bundle message
function showBundleMessage(message, type = "success") {
  const messageElement = document.getElementById("bundle-add-all-message");
  if (!messageElement) return;

  messageElement.textContent = message;
  messageElement.style.display = "block";

  if (type === "error") {
    messageElement.style.color = "#D82C0D";
  } else {
    messageElement.style.color = "#6C7863";
  }

  // Hide message after 5 seconds
  setTimeout(() => {
    messageElement.style.display = "none";
  }, 5000);
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      fieldset.querySelector(".form__label").lastChild.textContent = Array.from(
        fieldset.querySelectorAll("input")
      ).find((radio) => radio.checked).value;
      return Array.from(fieldset.querySelectorAll("input")).find((radio) => radio.checked).value;
      var checkedValue = document.querySelector(".product-form__input input:checked").value;
      document.getElementById("form__label").innerHTML = checkedValue;
      document.getElementById(".form__label span").addEventListener("mouseover", function () {
        document.querySelector(".form__label span").innerHTML = input.value;
      });
    });
  }

  updateTiered(html) {
    const newTieredContainers = html.querySelectorAll(".tiered-option__prices");
    const currentTieredContainers = document.querySelectorAll(".tiered-option__prices");

    if (newTieredContainers.length === currentTieredContainers.length) {
      newTieredContainers.forEach((newContainer, index) => {
        const currentContainer = currentTieredContainers[index];
        if (newContainer && currentContainer) {
          const newContent = newContainer.innerHTML.trim();

          if (newContent === "") {
            currentContainer.classList.add("hidden");
            currentContainer.innerHTML = "";
          } else {
            currentContainer.classList.remove("hidden");
            currentContainer.innerHTML = newContent;
          }
        }
      });
    }
  }

  updateStickyATC(html) {
    const stickyForm = document.querySelector("sticky-product-form");
    if (!stickyForm) return;

    // Extract elements from the sticky form
    const addButton = stickyForm.querySelector('[name="add"]');
    const addButtonText = stickyForm.querySelector('[name="add"] > span');

    if (!addButton || !addButtonText) return;

    // Get updated button from the rendered HTML
    const updatedButtonHtml = html.querySelector("sticky-product-form [name='add']");
    if (!updatedButtonHtml) return;

    // Copy disabled state
    if (updatedButtonHtml.hasAttribute("disabled")) {
      addButton.setAttribute("disabled", "disabled");

      // For disabled button, use simple text replacement or preserve SVG if present
      const currentContent = addButtonText.innerHTML;
      if (currentContent.includes("<svg") && currentContent.includes("cart-icon")) {
        // Extract SVG icon and update with appropriate status text
        const svgIcon = extractSvgIcon(currentContent);
        const statusText =
          this.currentVariant && !this.currentVariant.available
            ? window.variantStrings.soldOut
            : window.variantStrings.unavailable;

        addButtonText.innerHTML = svgIcon + " " + statusText;
      } else {
        // No SVG, just update text
        addButtonText.textContent =
          this.currentVariant && !this.currentVariant.available
            ? window.variantStrings.soldOut
            : window.variantStrings.unavailable;
      }
    } else {
      addButton.removeAttribute("disabled");

      // For enabled button, update with current variant price while preserving SVG
      const currentContent = addButtonText.innerHTML;
      if (currentContent.includes("<svg") && currentContent.includes("cart-icon")) {
        // Extract SVG icon and update text
        const svgIcon = extractSvgIcon(currentContent);
        const priceText = this.currentVariant ? ` - ${formatMoney(this.currentVariant.price)}` : "";
        const textContent = window.variantStrings.addToCart + priceText;

        // Set new content with SVG + updated text
        addButtonText.innerHTML = svgIcon + " " + textContent;
      } else {
        // If SVG is missing, re-render full content from original template
        const cartIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="cart-icon" style="width: 24px; height: 24px; vertical-align: middle; margin-bottom: 5px; display: inline-block;"><path d="M2.05005 2.05005H4.05005L6.71005 14.47C6.80763 14.9249 7.06072 15.3315 7.42576 15.6199C7.7908 15.9083 8.24495 16.0604 8.71005 16.05H18.49C18.9452 16.0493 19.3865 15.8933 19.7411 15.6079C20.0956 15.3224 20.3422 14.9246 20.4401 14.48L22.09 7.05005H5.12005M9 21C9 21.5523 8.55228 22 8 22C7.44772 22 7 21.5523 7 21C7 20.4477 7.44772 20 8 20C8.55228 20 9 20.4477 9 21ZM20 21C20 21.5523 19.5523 22 19 22C18.4477 22 18 21.5523 18 21C18 20.4477 18.4477 20 19 20C19.5523 20 20 20.4477 20 21Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
        const cartText = window.variantStrings.addToCart;
        const priceText = this.currentVariant ? ` - ${formatMoney(this.currentVariant.price)}` : "";

        addButtonText.innerHTML = `${cartIcon} ${cartText}${priceText}`;
      }
    }
  }
}

customElements.define("variant-radios", VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector("slideshow-component") &&
            this.classList.contains("complementary-products")
          ) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}

customElements.define("product-recommendations", ProductRecommendations);

// Page transition
window.addEventListener("beforeunload", () => {
  document.body.classList.add("unloading");
});
window.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("loaded");
});
window.addEventListener("pageshow", (event) => {
  // Removes unload class when returning to page via history
  if (event.persisted) {
    document.body.classList.remove("unloading");
  }
});

// Function to open cart drawer
function openCartDrawer() {
  try {
    console.log("Opening cart drawer...");

    // Method 1: Look for cart drawer toggle button and click it
    const cartDrawerToggle = document.querySelector(
      '[data-cart-drawer-toggle], [data-drawer-toggle="cart"], .js-drawer-open-cart, .cart-link, .cart-trigger'
    );
    if (cartDrawerToggle) {
      console.log("Found cart drawer toggle, clicking it");
      cartDrawerToggle.click();
      return;
    }

    // Method 2: Look for cart drawer element and add open class
    const cartDrawer = document.querySelector(
      ".cart-drawer, .drawer--right, #CartDrawer, .drawer__cart, .mini-cart"
    );
    if (cartDrawer) {
      console.log("Found cart drawer element, adding active/open classes");
      cartDrawer.classList.add("active", "open", "is-open", "drawer--is-open");
      document.body.classList.add("cart-drawer-open", "js-drawer-open", "drawer-open");
      return;
    }

    // Method 3: Try to find and click a cart icon
    const cartIcon = document.querySelector(
      ".cart-icon, .cart-icon-link, .site-header__cart, .header-cart"
    );
    if (cartIcon) {
      console.log("Found cart icon, clicking it");
      cartIcon.click();
      return;
    }

    // Method 4: Dispatch custom events that theme might listen for
    console.log("Dispatching custom cart open events");
    document.dispatchEvent(new CustomEvent("cart:open"));
    document.dispatchEvent(new CustomEvent("ajaxCart.open"));
    document.dispatchEvent(new CustomEvent("drawer:open", { detail: { drawer: "cart" } }));

    // Method 5: As a last resort, redirect to the cart page
    console.log("No cart drawer found, checking if we should redirect to cart page");
    setTimeout(() => {
      try {
        // If none of the above methods worked, redirect to cart page
        const cartDrawerVisible = document.querySelector(
          ".cart-drawer.active, .drawer--right.is-open, #CartDrawer.is-open, .drawer__cart.is-open, .mini-cart.is-open"
        );
        if (!cartDrawerVisible) {
          console.log("No cart drawer visible after attempts, redirecting to cart page");
          window.location.href = "/cart";
        }
      } catch (innerError) {
        console.error("Error in cart drawer visibility check:", innerError);
        // Fallback to cart page if there's an error
        window.location.href = "/cart";
      }
    }, 500);
  } catch (error) {
    console.error("Error opening cart drawer:", error);
    // Fallback to cart page if there's an error
    setTimeout(() => {
      window.location.href = "/cart";
    }, 500);
  }
}

// Make the function available globally
window.openCartDrawer = openCartDrawer;
